import poriKesk from './pori_kesk';

export default poriKesk;
